export async function loadModal() {
  const module = await import('./tnew/ui/Modal' /* webpackChunkName: "tnew-modal" */);
  return module.default;
}

export async function loadIssueCollector() {
  const module = await import('./tnew/issue-collector' /* webpackChunkName: 'tnew-issue-collector' */);
  return module.default;
}

export async function loadDatePicker() {
  const module = await import('./events/listing/ui/DatePicker' /* webpackChunkName: 'tnew-date-picker' */);
  return module.default;
}

export async function loadFlexTicketSelector() {
  const module = await import('./packages/flex/selections/ticketSelector/FlexTicketSelector' /* webpackChunkName: "tnew-flex-ticket-selector" */);
  return module.default;
}

export async function loadStateFilter() {
  const module = await import('./tnew/lib/StateFilter' /* webpackChunkName: "tnew-state-filter" */);
  return module.default;
}



// WEBPACK FOOTER //
// ./V7/AsyncLoader.js